import React from 'react';
import PropTypes from 'prop-types';
import { miFields } from './CasePracticeForm';
import { FieldFeedbackBody } from './CaseGuidePanel';
import { CoherenceBody } from './CaseOverviewPanel';

// 항목 하나의 작성 글과 AI 피드백을 나란히 보여준다.
function ReportField({ field, text, feedback }) {
    return <section className="case-report-field" aria-labelledby={`report-${field.key}`}>
        <div className="case-report-text">
            <h3 id={`report-${field.key}`}>{field.label}</h3>
            {text.trim() ? <p>{text}</p> : <p className="ai-small">작성하지 않았습니다.</p>}
        </div>
        <div className="case-report-feedback">
            <span className="ai-kicker">AI FEEDBACK</span>
            {feedback ? <FieldFeedbackBody data={feedback} /> : <p className="ai-small">이 항목의 피드백이 없습니다.</p>}
        </div>
    </section>;
}

// 저장된 사례개념화를 읽기 전용으로 보여준다(항목별 글 · 피드백, 연결 점검).
export default function ConceptualizationReport({ result }) {
    const filled = miFields.filter(field => (result.values[field.key] || '').trim()).length;
    return <div className="case-report">
        <article className="review-card">
            <span className="ai-kicker">CASE CONCEPTUALIZATION</span>
            <div className="review-row"><h2>작성한 사례개념화</h2><span className="review-tag">{filled} / {miFields.length} 항목 작성</span></div>
            {miFields.map(field => <ReportField key={field.key} field={field} text={result.values[field.key] || ''} feedback={result.fields[field.key]} />)}
        </article>
        <article className="review-card">
            <span className="ai-kicker">AI CONNECTION CHECK</span>
            <h2>항목 간 연결 점검</h2>
            {result.coherence ? <CoherenceBody data={result.coherence} /> : <p className="ai-small">연결 점검을 받지 않았습니다.</p>}
        </article>
        <p className="ai-small">AI가 작성 내용을 읽고 만든 학습용 피드백입니다. 정답이나 평가 결과가 아닙니다.</p>
    </div>;
}

ReportField.propTypes = {
    field: PropTypes.shape({ key: PropTypes.string.isRequired, label: PropTypes.string.isRequired }).isRequired,
    text: PropTypes.string.isRequired,
    feedback: PropTypes.object,
};

ConceptualizationReport.propTypes = {
    result: PropTypes.shape({
        values: PropTypes.objectOf(PropTypes.string).isRequired,
        fields: PropTypes.object.isRequired,
        coherence: PropTypes.object,
    }).isRequired,
};
